import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { FullLayoutComponent } from "./layouts/full-layout/full-layout.component";
import { CommonLayoutComponent } from "./layouts/common-layout/common-layout.component";

import { FullLayout_ROUTES } from "./shared/routes/full-layout.routes";
import { CommonLayout_ROUTES } from "./shared/routes/common-layout.routes";
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { MainLayout_ROUTES } from './shared/routes/main-layout.routes';

const appRoutes: Routes = [
    {
        path: 'dashboard',
        redirectTo: '/dashboard/default',
        pathMatch: 'full',
    },
    {
        path: 'login',
        redirectTo: '/authentication/login',
        pathMatch: 'full',
    },
    {
        path: 'signup',
        redirectTo: '/authentication/signup',
        pathMatch: 'full',
    },
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
    },
    { 
        path: '', 
        component: CommonLayoutComponent,
        children: CommonLayout_ROUTES 
    },
    { 
        path: '', 
        component: FullLayoutComponent, 
        children: FullLayout_ROUTES
    },
    { 
        path: '', 
        component: MainLayoutComponent, 
        children: MainLayout_ROUTES
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, { 
            preloadingStrategy: PreloadAllModules,
            anchorScrolling: 'enabled',
            scrollPositionRestoration: 'enabled' 
        })
    ],
    exports: [
        RouterModule
    ]
})

export class AppRoutingModule {
}